import React, { Component } from 'react';
import { getTranslation } from '../Utilities/GetTranslation';
import ReactTable from 'react-table';
import FormTablePagination from './FormTablePagination';

declare var $;

/* eslint-disable react/forbid-foreign-prop-types */
// @ts-ignore
delete ReactTable.propTypes.TableComponent;
// @ts-ignore
delete ReactTable.propTypes.TheadComponent;
// @ts-ignore
delete ReactTable.propTypes.TbodyComponent;
// @ts-ignore
delete ReactTable.propTypes.TrGroupComponent;
// @ts-ignore
delete ReactTable.propTypes.TrComponent;
// @ts-ignore
delete ReactTable.propTypes.ThComponent;
// @ts-ignore
delete ReactTable.propTypes.TdComponent;
// @ts-ignore
delete ReactTable.propTypes.TfootComponent;
// @ts-ignore
delete ReactTable.propTypes.FilterComponent;
// @ts-ignore
delete ReactTable.propTypes.ExpanderComponent;
// @ts-ignore
delete ReactTable.propTypes.PivotValueComponent;
// @ts-ignore
delete ReactTable.propTypes.AggregatedComponent;
// @ts-ignore
delete ReactTable.propTypes.PivotComponent;
// @ts-ignore
delete ReactTable.propTypes.PaginationComponent;
// @ts-ignore
delete ReactTable.propTypes.PreviousComponent;
// @ts-ignore
delete ReactTable.propTypes.NextComponent;
// @ts-ignore
delete ReactTable.propTypes.LoadingComponent;
// @ts-ignore
delete ReactTable.propTypes.NoDataComponent;
// @ts-ignore
delete ReactTable.propTypes.ResizerComponent;
// @ts-ignore
delete ReactTable.propTypes.PadRowComponent;
/* eslint-enable react/forbid-foreign-prop-types */

class FormTable extends Component {
    constructor(props) {
        super(props);
        
        this.onPageChange = this.onPageChange.bind(this);
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    filterCaseInsensitive(filter, row) {
        const id = filter.pivotId || filter.id;
        if (row[id] !== null) {
            return (
                row[id] !== undefined ?
                    String(row[id].toString().toLowerCase())
                        .includes(filter.value.toString().toLowerCase()) : true
            );
        }
    }

    onPageChange() {
        // re initialize tooltip after page change
        $('[data-toggle="tooltip"]').tooltip("destroy");
        setTimeout(() => { $('[data-toggle="tooltip"]').tooltip(); }, 250);

        if (this.props.onPageChange == null) {
            return;
        }

        this.props.onPageChange();
    }

    render() {

        let defaultPageSize = 20;

        return (
            <ReactTable 
                data={this.props.data} 
                columns={this.props.columns}
                expanded={this.props.expanded}
                defaultFiltered={this.props.defaultFiltered}
                defaultFilterMethod={this.filterCaseInsensitive}
                defaultPageSize={defaultPageSize}   
                defaultSorted={this.props.defaultSorted}         
                minRows={0}
                filterable={this.props.filterable}                
                pivotBy={this.props.pivotBy}
                getTrProps={this.props.getTrProps}
                previousText={getTranslation("sns.general.previous")}
                nextText={getTranslation("sns.general.next")}
                loadingText={getTranslation("sns.general.loading")}
                noDataText={getTranslation("sns.general.nodata")}
                ofText={getTranslation("sns.general.pageof")}
                rowsText={getTranslation("sns.general.rows")}
                rowsOfText={getTranslation("sns.general.rowsof")}
                totalRowsText={getTranslation("sns.general.totalrows")}
                showPaginationTop
                showPaginationBottom
                SubComponent={this.props.SubComponent}
                PaginationComponent={FormTablePagination}
                onPageChange={this.onPageChange}
                onExpandedChange={this.props.onExpandedChange}
                onFilteredChange={this.props.onFilteredChange}
            />
        );
    }
}

export default FormTable;


// WEBPACK FOOTER //
// ./src/Fields/FormTable.js